import apiConfig from "@/services/apiConfig";
import apiClient from "@/services/apiClient";

const atualizar = (biometria, idCliente) => {
  const requestData = {
    IdCliente: idCliente,
    Biometria: biometria,
  };
  const urlRequest = apiConfig.getUrlCrmApi() + "/api/Biometria/Atualizar";
  return new Promise((resolve, reject) => {
    apiClient
      .post(urlRequest, requestData, {
        headers: { AuthToken: apiConfig.getTokenLogin() },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const verificarCadastro = (idCliente) => {
  const urlRequest = apiConfig.getUrlCrmApi() + "/api/Biometria/VerificarCadastro/" + idCliente;
  return new Promise((resolve, reject) => {
    apiClient
      .get(urlRequest, {
        headers: { AuthToken: apiConfig.getTokenLogin() },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


const biometriaApiService = {
  atualizar,
  verificarCadastro
};

export default biometriaApiService;
